import Vue from 'vue'
import { Lazyload  } from 'vant';

Vue.use(Lazyload, {
  lazyComponent: true,
});